(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('CompanyPagesController', CompanyPagesController);

  /* ngInject */
  function CompanyPagesController($state, $stateParams, Flash, companyPageService, smcProfileService, sessionService) {
    const vm = this;

    vm.deleteCompanyPage = deleteCompanyPage;
    vm.companyPages = [];
    vm.loading = false;
    vm.profile = {};
    vm.profileId = $stateParams.profileId;
    vm.shareCompanyPage = shareCompanyPage;
    vm.unshareCompanyPage = unshareCompanyPage;

    activate();

    function activate() {
      getCompanyPages();
      getProfile();
    }

    function deleteCompanyPage(companyPage) {
      companyPageService(sessionService.getAuthToken()).destroy({ profileId: vm.profileId, id: companyPage.id }, _ => {
        $state.reload();
        Flash.create('success', 'Company page successfully deleted.');
      });
    }

    function getCompanyPages() {
      vm.loading = true;

      companyPageService(sessionService.getAuthToken()).query({ profileId: vm.profileId }, response => {
        vm.companyPages = response;
        vm.loading = false;
      }, _ => {
        vm.loading = false;
      });
    }

    function getProfile() {
      smcProfileService(sessionService.getAuthToken()).get({ id: vm.profileId }, response => vm.profile = response);
    }

    function shareCompanyPage(companyPage) {
      companyPageService(sessionService.getAuthToken()).share({ profileId: vm.profileId, id: companyPage.id }, _ => {
        $state.reload();
        Flash.create('success', 'Company page successfully shared with organization.');
      });
    }

    function unshareCompanyPage(companyPage) {
      companyPageService(sessionService.getAuthToken()).unshare({ profileId: vm.profileId, id: companyPage.id }, _ => {
        $state.reload();
        Flash.create('success', 'Company page successfully unshared with organization.');
      });
    }
  }
})();
